import React from "react";
import styled from "styled-components";
import { ellipsis } from "@glossy";

const Toggle = styled.div`
  cursor: pointer;
  ${ellipsis()};
`;

export const DROPDOWN_ROLE = "toggle";

interface IProps {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  children: React.ReactNode;
}

const KomonDropdownToggle = ({ onClick, className, children }: IProps) => (
  <Toggle className={className} onClick={onClick}>
    {children}
  </Toggle>
);

KomonDropdownToggle.displayName = "KomonDropdownToggle";
export default KomonDropdownToggle;
